t = require('views/internal/teacup-with-helpers')('board_header')

module.exports = t.renderable ({ canRename, orgLogoUrl, orgLogoUrl2x, hasBusinessClass, isBusinessClass, isEnterprise, orgDisplayName, name, orgName, isLoggedIn, isAdmin, isPrivateTeam, isUntitled, subscribeString, showCopyButton }) ->

  boardType = (if isBusinessClass then 'BC' else if isEnterprise then 'ENT' else 'Free')

  classes =
    'board-header-btn': true
    'board-header-btn-name': true
    'js-rename-board': canRename
    'no-edit': !canRename
    'should-rename': isUntitled && canRename

  displayNameClasses =
    'board-header-btn': true
    'board-header-btn-org-name': true
    'js-open-org-menu': true
    'board-header-btn-without-icon': !orgLogoUrl

  t.a { href: '#', class: t.classify(classes) }, ->
    t.span '.board-header-btn-text', { dir: 'auto' }, ->
      t.text name

  if isLoggedIn
    t.a '.board-header-btn.js-star-board', { href: '#', title: t.l('click-to-star-or-unstar-this-board-starred-boards-show-up-at-the-top-of-your-boards-list'), 'aria-label': t.l('star-or-unstar-board') }, ->
      t.icon 'star', { class: 'board-header-btn-icon' }

  if orgDisplayName
    t.span '.board-header-btn-divider'
    t.a { href: '/' + orgName, class: t.classify(displayNameClasses), data: { boardtype: boardType } }, ->
      if orgLogoUrl
        t.img
          class: 'board-header-btn-name-org-logo'
          src: orgLogoUrl
          srcSet: "#{orgLogoUrl} 1x, #{orgLogoUrl2x} 2x"
      t.span '.board-header-btn-text', ->
        t.text orgDisplayName
        t.span '.org-label', ->
          t.text boardType
    t.span '.board-header-btn-divider'

  t.div '.board-header-btns.mod-left', ->
    t.a '.board-header-btn.hide.js-open-desc.js-fill-desc', { href: '#' }, ->
      t.icon 'description', { class: 'board-header-btn-icon' }

    if !orgDisplayName
      t.span '.board-header-btn-divider'
      if isPrivateTeam
        t.span '.board-header-btn.board-header-btn-without-icon.board-header-btn-text.no-edit', ->
          t.format 'private-team'
      else
        t.a '.board-header-btn.board-header-btn-without-icon.board-header-btn-text.js-add-board-to-team', { href: '#', class: t.classify('no-edit': !isAdmin) }, ->
          t.format 'personal'
      t.span '.board-header-btn-divider'

    t.a '.board-header-btn.perms-btn.js-change-vis', { href: '#', id: 'permission-level' }
    t.span '.board-header-btn-divider.js-collection-divider.hide'
    t.a '.board-header-btn.hide.js-collection', { href: '#' }, ->
      t.img '.board-header-btn-icon.icon-sm.collection-icon-img.dark-icon', { src: require('images/collections/collections-black.svg') }
      t.img '.board-header-btn-icon.icon-sm.collection-icon-img.light-icon', { src: require('images/collections/collections.svg') }

  t.div '.board-header-btns.mod-right', ->

    t.a '.board-header-btn.board-header-btn-filter-indicator.hide.js-filter-cards-indicator', { href: '#' }, ->
      t.icon 'filter', { class: 'board-header-btn-icon' }
      t.span '.board-header-btn-text.u-text-underline', ->
        t.format 'filtering-is-on'
      t.icon 'close', { class: 'board-header-btn-icon-close js-filter-card-clear' }

    t.a '.board-header-btn.sub-btn.hide.js-board-header-subscribed', { href: '#' }, ->
      t.icon 'subscribe', { class: 'board-header-btn-icon' }
      t.span '.board-header-btn-text.u-text-underline', ->
          # EXPERIMENT: subscribeToWatchOrFollow
          t.format subscribeString

    t.a '.board-header-btn.calendar-btn.hide.js-calendar', { href: '#' }, ->
      t.icon 'calendar', { class: 'board-header-btn-icon' }
      t.span '.board-header-btn-text.u-text-underline', ->
        t.format 'calendar'

    t.span '.js-plugin-header-btns'

    if isLoggedIn && showCopyButton
      t.a '.board-header-btn.js-copy-board', { href: '#' }, ->
        t.icon 'board', { class: 'board-header-btn-icon' }
        t.span '.board-header-btn-text.u-text-underline', ->
          t.format 'copy-board'

    t.a '.board-header-btn.mod-show-menu.js-show-sidebar', { href: '#' }, ->
      t.icon 'overflow-menu-horizontal', { class: 'board-header-btn-icon' }
      t.span '.board-header-btn-text.u-text-underline', ->
        t.format 'show-menu'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_header.coffee